import { lazy, Suspense } from 'react';
import { Outlet, Navigate, type RouteObject } from 'react-router';

import { useSigmaDashboards } from 'src/hooks/use-sigma-query';

import { CONFIG } from 'src/global-config';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';

import { usePathname } from '../hooks';

// ---------------------------------------------------------------
const SigmaPage = lazy(() => import('src/pages/dashboard/sigma'));

function DashboardLandingRedirect() {
  const { data: dashboards = [], isLoading } = useSigmaDashboards();

  if (isLoading) return <LoadingScreen />;

  if (!dashboards.length) return <SigmaPage />;

  return <Navigate to={dashboards[0].slug} replace />;
}

function SuspenseOutlet() {
  const pathname = usePathname();
  return (
    <Suspense key={pathname} fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  );
}

const dashboardLayout = () => (
  <DashboardLayout>
    <SuspenseOutlet />
  </DashboardLayout>
);

// ---------------------------------------------------------------

export const dashboardRoutes: RouteObject[] = [
  {
    path: 'dashboard',
    element: CONFIG.auth.skip ? dashboardLayout() : <AuthGuard>{dashboardLayout()}</AuthGuard>,
    children: [
      { index: true, element: <DashboardLandingRedirect /> },
      { path: ':slug', element: <SigmaPage /> },
    ],
  },
];
